export const getNumberFormat = (value: number | string): string => {
    if (typeof value === "string") {
        return value;
    }

    return Intl.NumberFormat("pl-PL", {
        useGrouping: true
    }).format(value);
};
export const getNumberFormat = (value: number | string): string => {
    if (typeof value === "string") {
        return value;
    }

    return Intl.NumberFormat("pl-PL", {
        useGrouping: true
    }).format(value);
};
